module.exports = __webpack_public_path__ + "img/carousel-1-slide-4.b3119e04.webp";